export default "dist/images/block-count-up-side.b0e7f65.png";